import { NuqsAdapter } from 'nuqs/adapters/react';

// eslint-disable-next-line no-restricted-imports
import '@/app/lib/dayjs-config';

import { AuthFailurePopupProvider } from '@/features/auth-failure-popup';
import { PlanMigrationProvider } from '@/features/plan-migration';

import { useViewerEmail, useViewerPhone } from '@/entities/viewer';

import { MobileMenuProvider } from '@/shared/lib/contexts';
import { MetaPixelProvider } from '@/shared/lib/fbpixel';
import { CookieConsent } from '@/shared/ui/cookie-consent';

import { AntConfigProvider } from './providers/ant-config';
import { AntMessageProvider } from './providers/ant-message';
import { AntModalProvider } from './providers/ant-modal';
import { AntNotificationProvider } from './providers/ant-notification';
import { ErrorBoundaryProvider } from './providers/error-boundary';
import { GoogleAuthProvider } from './providers/google-auth';
import { I18nProvider } from './providers/i18n';
import { RecaptchaProvider } from './providers/recaptcha';
import { ReferralProvider } from './providers/referral';
import { AppRouter } from './providers/router';
import { StoreProvider } from './providers/store';
import { ThemeProvider } from './providers/theme';
import { TourProvider } from './providers/tour';

import './styles/index.css';
import 'antd/dist/reset.css';

function AppContent() {
    const userEmail = useViewerEmail();
    const userPhone = useViewerPhone();

    return (
        <AuthFailurePopupProvider>
            <PlanMigrationProvider>
                <MetaPixelProvider
                    userEmail={userEmail}
                    userPhone={userPhone}
                >
                    <AppRouter />
                </MetaPixelProvider>
            </PlanMigrationProvider>
        </AuthFailurePopupProvider>
    );
}

export function App() {
    return (
        <NuqsAdapter>
            <ReferralProvider>
                <StoreProvider>
                    <CookieConsent />
                    <ErrorBoundaryProvider>
                        <GoogleAuthProvider>
                            <RecaptchaProvider>
                                <ThemeProvider>
                                    <I18nProvider>
                                        <AntConfigProvider>
                                            <AntNotificationProvider>
                                                <AntMessageProvider>
                                                    <AntModalProvider>
                                                        <MobileMenuProvider>
                                                            <TourProvider>
                                                                <AppContent />
                                                            </TourProvider>
                                                        </MobileMenuProvider>
                                                    </AntModalProvider>
                                                </AntMessageProvider>
                                            </AntNotificationProvider>
                                        </AntConfigProvider>
                                    </I18nProvider>
                                </ThemeProvider>
                            </RecaptchaProvider>
                        </GoogleAuthProvider>
                    </ErrorBoundaryProvider>
                </StoreProvider>
            </ReferralProvider>
        </NuqsAdapter>
    );
}
